"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.LoadingState = void 0;

/**
 * Interface to indicate loading status on a Redux store property.
 */
var LoadingState;
exports.LoadingState = LoadingState;

(function (LoadingState) {
  LoadingState["notLoaded"] = "notLoaded";
  LoadingState["loaded"] = "loaded";
  LoadingState["loading"] = "loading";
  LoadingState["refreshing"] = "refreshing";
  LoadingState["paging"] = "paging";
  LoadingState["error"] = "error";
})(LoadingState || (exports.LoadingState = LoadingState = {}));